export default "__VITE_ASSET__BTmEk7Us__"